import http from "./httpService";
import config from "./config.json";

export const getCourses = () => {
  return http.get(`${config.bestlearnapi}/courses`);
};

export const getCourse = (courseId: string) => {
  return http.get(`${config.bestlearnapi}/course/${courseId}`);
};

export const newCourse = (course: any) => {
  return http.post(`${config.bestlearnapi}/admin/course`, course, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const updateCourse = (courseId: string, course: any) => {
  return http.put(`${config.bestlearnapi}/admin/course/${courseId}`, course);
};

export const deleteCourse = (courseId: string) => {
  return http.delete(`${config.bestlearnapi}/admin/course/${courseId}`);
};
